import { useCallback, useEffect, useState } from "react";
import { CiSearch } from "react-icons/ci";
import { allCommunityFeeds, searchCommunityFeeds } from "../../redux/api";
import EmptyStateComponent from "../EmptyStateCard";
import Loader from "../Loader";
import CommunityPostCard from "./CommunityPostCard";

const Feeds = ({ handleSearch, currentLocation, darktheme }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [feeds, setFeeds] = useState(null);

  const [isLoading, setisLoading] = useState(false);
  const [, setLoadingMore] = useState(false);
  const [page] = useState(1);

  const getFeeds = useCallback(async () => {
    try {
      setisLoading(true);
      const { data } = await allCommunityFeeds(
        currentLocation?.latitude,
        currentLocation?.longitude
      );
      if (data) {
        setFeeds(data?.data?.communities);
        setisLoading(false);
        setLoadingMore(true);
      }
    } catch (error) {
      setisLoading(false);
    }
  }, []);

  const handleSearchFeeds = useCallback(
    async (searchTerm) => {
      setisLoading(true);
      try {
        const { data } = await searchCommunityFeeds(searchTerm.trim(), page);
        const reshapedData = data.hits.map((hit) => ({
          category: hit.document.category,
          comment: "on",
          commentCount: hit.document.commentCount,
          community: {
            id: hit.document.communityID,
            communityID: hit.document.communityID,
            communityName: hit.document.community.communityName,
            communityDesc: hit.document.community.communityDesc,
            communityCoverPhoto: hit.document.community.communityCoverPhoto,
          },
          communityID: hit.document.communityID,
          coords: {
            latitude: currentLocation?.latitude,
            longitude: currentLocation?.longitude,
          },
          createdAt: hit.document.createdAt,
          createdAt_unix: hit.document.createdAt_unix,
          id: hit.document.id,
          likeCount: hit.document.likeCount,
          likedBy: [],
          media: hit.document.media,
          notify: "on",
          sharedBy: [],
          sharedCount: 0,
          status: hit.document.status,
          text: hit.document.text,
          title: hit.document.title,
          type: hit.document.type,
          userId: hit.document.userId,
          userImage: hit.document.userImage,
          username: hit.document.username,
        }));
        if (data) {
          setFeeds(reshapedData);
          setisLoading(false);
        }
      } catch (error) {
        setisLoading(false);
      }
    },
    [currentLocation?.latitude, currentLocation?.longitude, page]
  );

  useEffect(() => {
    const delay = setTimeout(() => {
      if (searchTerm) {
        handleSearchFeeds(searchTerm);
      } else {
        getFeeds();
      }
    }, 500);

    return () => clearTimeout(delay);
  }, [searchTerm, handleSearchFeeds, getFeeds]);

  return (
    <div className="pb-[3rem]">
      {isLoading ? (
        <div className="flex h-[50vh] items-center justify-center">
          <Loader />
        </div>
      ) : (
        <div>
          <div
            className={`flex items-center w-full h-[50px] mb-[1rem] px-5 ${
              darktheme ? "bg-[black]" : "bg-[#F9FAFB]"
            } rounded-[43px]`}
          >
            <input
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search feeds"
              className="w-full h-full bg-transparent rounded-[43px] border-none outline-none"
            />
            <CiSearch size={24} onClick={handleSearch} />
          </div>

          {feeds?.length === 0 ? (
            <EmptyStateComponent
              title="There are no feeds around you currently"
              titleClass="w-full md:w-[248px] mx-auto my-[8px] text-[24px] font-[700] leading-[22px]"
            />
          ) : (
            feeds?.map((item, index) => (
              <CommunityPostCard
                key={index}
                data={item}
                theme={darktheme}
                coords={currentLocation}
              />
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default Feeds;
